import { render, staticRenderFns } from "./PointsAdjustmentModal.vue?vue&type=template&id=188deee4&scoped=true"
import script from "./PointsAdjustmentModal.vue?vue&type=script&lang=js"
export * from "./PointsAdjustmentModal.vue?vue&type=script&lang=js"
import style0 from "./PointsAdjustmentModal.vue?vue&type=style&index=0&id=188deee4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188deee4",
  null
  
)

export default component.exports